<template>

<!-- $root.page_loader -->
    <div class="productPagesk" v-if=" ProductDetailLoader" >
        <PuSkeleton  class=" Skeleton1"  width="100%" height="inherit"  />
      <div class="productPageSkeleton">
        <PuSkeleton  class=" Skeleton2"  width="100%" height="inherit"  />
        <PuSkeleton  class=" Skeleton3"  width="100%" height="inherit"  />
      </div>
    </div>
  <div v-else>

    
    <div class="container-fluid product-detail-container"  >
      
      <!-- <div class="product_loader" v-show="master_sku === ''">
        <loading-icon class="loading-icon newLoader" name="ball-clip-rotate-multiple" color="#ba2126" scale="1"></loading-icon>
      </div> -->
          <nav aria-label="breadcrumb" class="detail-page-breadcrumb breadcrumb-hide plpBread">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link  :to="{path:'/'}">Home</router-link >
              </li>
              <li class="breadcrumb-item" v-for="(item, index) in this.pdpBreadcrumb" :key="index" >
                <router-link  :to="'/category/' + item.url_key+ '.html'">
                  {{item.name}}	 
                </router-link >
                <!-- <nuxt-link :to="{path:'/category/'+item.url_key+'.html'}" v-text="item.name">
                
                </nuxt-link> -->
                <!-- {{item.url_key}}  -->
              </li>  
            </ol> 

          </nav> 
      <!-- <div
				class="success_message"
				v-text="this.$root.success_message"
				v-if="this.$root.success_message != ''"
			></div> -->
      <!-- <div
        class="error_message"
        v-text="this.$root.error_message"
        v-if="this.$root.error_message != ''"
      ></div> -->
      <!-- <div class="row" v-if="this.free_offer==true">
                <div class="col-12 free-offer">
                    <p>Get bag worth INR 1999/- absolutely FREE on purchase of W footwear worth INR 1999/- or more. <br>Step 1: Add Footwear worth 1999 in the cart. <br>Step 2: <router-link to="/bags.html" class="font-bold" style="color: #fff;text-decoration:underline;">Click here</router-link> to add bag in the cart.<br>Step 3: Use coupon code <b class="font-bold">FREEBAG</b> in the cart to avail this.</p>
                </div>
            </div> -->
      <div class="row container-fluid" v-show="master_sku != ''">
        <div
          class="col-md-6 col-sm-12 col-xs-12 text-center productImage"
          v-if="gallery.length === 0"
        >
         <responsive-image

          v-bind:desktop="`${$root.image_url_c}inside/470x470/${placeholder_image}`"
          v-bind:tab="`${$root.image_url_c}inside/470x470/${placeholder_image}`"
          v-bind:mobile="`${$root.image_url_c}inside/470x470/${placeholder_image}`"
          v-bind:default_image="`${$root.image_url_c}inside/470x470/${placeholder_image}`"
        />
         
        </div>
        <!-- id="lightgallery" -->
        <div
          class="col-md-6 col-sm-12 productImage forDesktop"
          v-if="gallery.length && showProductImages"
        >
          <slick ref="slick" :options="slickOptions" class="main-slider">
            <zoom-on-hover
              v-for="(item, index) in gallery"
              :data-src="item.image"
              :alt="name"
              :key="index"
              :title="name"
              :scale="2"
              :img-normal="`${$root.image_url_c}inside/470x470/${item.image}`"
            ></zoom-on-hover>
          </slick>
          <slick ref="slick1" :options="slickOptionsImage" class="slick-thumb">
             <responsive-image
              v-for="(item, index) in gallery"
               :key="index"
               :alt="name"
              :title="name"
              v-on:click="changeProductImage(index)"
              v-bind:desktop="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:tab="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:mobile="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:default_image="`${$root.image_url_c}inside/470x470/${item.image}`"
              
              custom_class="w-100"
              />
          </slick>
        </div>
        <div
          class="col-md-6 col-sm-12 productImage forMobile"
          v-if="gallery.length && showProductImages"
        >
          <slick
            ref="slick"
            :options="slickOptions"
            class="main-slider"
            id="lightgallery"
          >
          <img 
          v-for="(item, index)  in gallery"  
          :data-lazy="`${$root.image_url_c}inside/470x470/${item.image}`"
          :data-src="`${$root.image_url_c}inside/470x470/${item.image}`"
          class="w-100" 
          :key="index"
          :src="`${$root.image_url_c}inside/470x470/${item.image}`"
          >
             <!-- <responsive-image
              v-for="(item, index) in gallery"
               :key="index"s
               :alt="name"
              :title="name"
              v-on:click="changeProductImage(index)"
              v-bind:desktop="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:tab="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:mobile="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:default_image="`${$root.image_url_c}inside/470x470/${item.image}`"
              
              custom_class="w-100"
              /> -->
          </slick>
          <slick ref="slick1" :options="slickOptions1" class="slick-thumb">
            <img 
            v-for="(item, index)  in gallery"  
            :data-lazy="`${$root.image_url_c}inside/470x470/${item.image}`" 
            :data-src="`${$root.image_url_c}inside/470x470/${item.image}`" 
            class="w-100" 
            :key="index"
             :src="`${$root.image_url_c}inside/470x470/${item.image}`"
            >
             <!-- <responsive-image
              v-for="(item, index) in gallery"
               :key="index"
               :alt="name"
              :title="name"
              v-on:click="changeProductImage(index)"
              v-bind:desktop="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:tab="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:mobile="`${$root.image_url_c}inside/470x470/${item.image}`"
              v-bind:default_image="`${$root.image_url_c}inside/470x470/${item.image}`"
              
              custom_class="w-100"
              /> -->
          </slick>
          <!-- <div class="img-zoom-result" id="productImageMainZoom"></div> -->
        </div>
        <div class="col-md-6 col-sm-12 content-section">
          <div class="basicDetail">
              <img class="expressDelivery" v-if="isExpressProduct == true" src="/img/expressDelivery.png" alt="">
               
            <h1 class="brandName" v-text="brandName"></h1>
            <h1 class="page-title" v-text="name"></h1>
            <div class="ratingReview">
              <div class="stars">
                <input
                  class="star productReview"
                  type="radio"
                  value="5"
                  v-model="reviews.average_rating"
                  readonly
                  name="star"
                />
                <label class="star"></label>
                <input
                  class="star productReview"
                  type="radio"
                  value="4"
                  v-model="reviews.average_rating"
                  readonly
                  name="star"
                />
                <label class="star"></label>
                <input
                  class="star productReview"
                  type="radio"
                  value="3"
                  v-model="reviews.average_rating"
                  readonly
                  name="star"
                />
                <label class="star"></label>
                <input
                  class="star productReview"
                  type="radio"
                  value="2"
                  v-model="reviews.average_rating"
                  readonly
                  name="star"
                />
                <label class="star"></label>
                <input
                  class="star productReview"
                  type="radio"
                  value="1"
                  v-model="reviews.average_rating"
                  readonly
                  name="star"
                />
                <label class="star"></label>
              </div>
              <div class="productRatings">
                <span>{{ reviews.total_review }} </span> Reviews |
                <span>{{ reviews.average_rating }}</span> Ratings
              </div>
            </div>

            <!-- <p class="product-sku"><span class="font-medium">SKU: </span> <span v-text="master_sku"></span></p> -->
            <div class="price">
              <!-- v-if="selling_price != price" -->
              <p>
                <span class="font-medium">{{
                  selling_price | formatMoney
                }}</span>
                <span
                  class="old-price"
                  v-if="
                    formatDiscountPrice(selling_price) !=
                    formatDiscountPrice(price)
                  " >{{ price | formatMoney }}</span
                >

                <span
                  class="discount_percent"
                  v-if="product_type != 'gift' && formatDiscountPrice(selling_price) != formatDiscountPrice(price)"
                  >{{ $root.percentOff(price,selling_price)}}</span
                >
              </p>
              <p class="taxes">Inclusive of all taxes</p>
            </div>
          </div>

          <div
            v-if="this.isSelectableWithoutSize == false"
            class="size-container"
            v-bind:class="[size_active ? '' : 'active']"
          >
          <h3 class="productsHighlight">Select Size <label>
                  <a
                    v-if="isSizeChart"
                    href="#"               
                    class="size-guide"
                    @click.prevent="size_popup_show"
                    >Size chart</a
                  >
                </label></h3>
            <div class="size-bg">
              <div class="close" @click="size_close">
                <i class="fa fa-times"></i>
              </div>
             
              <label v-if="product_type == 'gift'">Select Gift Amount</label>
              <div class="size-box">
                <label
                  class="size select-one-size"
                  v-for="(items, i) in variation"
                  @click="select_size(items)"
                  :key="i"
                  v-bind:class="{
                    disabled: items.quantity <= '0',
                    selected:
                      size.select_size === items.configrable_atribute_value ||
                      size.select_size === i,
                  }"
                >
                  {{ items.configrable_atribute_value ? "" : i }}

                  <input
                    type="radio"
                    v-model="size"
                    name="size"
                    :value="{
                      select_size: items.configrable_atribute_value || i,
                      max_qty: items.quantity,
                      variant_id: items.id_product,
                      sku: items.sku,
                    }"
                    v-bind:disabled="items.quantity <= '0' === true"
                  /><span v-text="items.configrable_atribute_value"></span>
                </label>
                
                <p class="section_error">{{ size_error }}</p>
                <p
                  class="font-medium"
                  style="color: #02bb02; font-size: 12px"
                  v-if="
                    this.size.max_qty === '1' && this.size.select_size != ''
                  "
                >
                  1 left.
                </p>
              </div>
              <!-- <div class="otherOptionsMobile" v-if="seeOtherBuying.length > 0">
								<p @click="toggleSeeOtherBuying">See other buying options</p>
							</div> -->
              <div class="soldByMobile">
                <span> Sold By</span>
                <router-link
                  :to="{ path: '/store.html', query: { store: storeId } }"
                >
                  {{ this.storeName }}
                </router-link>
              </div>
            </div>
          </div>

          <div class="add-to-cart-container">
            <div
              class="add-to-cart-btns"
              v-if="product_type != 'gift' && !isAddedToCart"
            >
              <button
                type="button"
                v-ripple
                class="add-to-cart btn"
                id="product-addtocart-button"
                title="Add to cart"
                @click="add_to_cart($event)"
                v-if="this.stock_status === 'out-of-stock' || AvailableQuantity==0 "
                v-bind:disabled="
                  this.stock_status === 'out-of-stock' || AvailableQuantity==0 
                "
              >
                Out of stock
              </button>
              <button
                type="button"
                v-ripple
                class="add-to-cart btn"
                id="product-addtocart-button"
                title="Add to cart"
                @click="add_to_cart($event)"
                v-if="stock_status != 'out-of-stock' && AvailableQuantity!=0"
              >
                <img
                  src="img/shoppingCart.png"
                  alt=""
                  style="margin-right: 10px"
                />
                Add to cart
              </button>
              <button
                type="button"
                v-ripple
                class="buy-now btn"
                id="buy-now"
                title="Buy now"
                @click="buyNow()"
                v-bind:disabled="
                 stock_status === 'out-of-stock' || AvailableQuantity==0
                "
              >
                <img
                  src="img/shoppingBag.png"
                  alt=""
                  style="margin-right: 10px"
                />
                Buy Now
              </button>
              <!-- <div class="otherOptions" v-if="seeOtherBuying.length > 0">
								<p @click="toggleSeeOtherBuying">See other buying options</p>
							</div> -->
              <div class="wishList">
                <!-- <a href="#" @click.prevent="openModel"  v-if="(return_policy !='' && return_policy != null)"> Return Policy</a> -->

                <p @click="addToWishList" class="pl-0 ml-0">
                  <i class="fa fa-heart-o pr-3"></i>Add to wishlist
                </p>
              </div>

            </div>
            <div class="add-to-cart-btns" v-else>
              <router-link
                class="newContinueShop"
                :to="{ path: '/store.html', query: { store: storeId } }"
              >
                Continue Shopping
              </router-link>

              <!-- <div class="otherOptions" v-if="seeOtherBuying.length > 0">
								<p @click="toggleSeeOtherBuying">See other buying options</p>
							</div> -->
              <div class="wishList" @click="addToWishList">
                <p>Add to wishlist</p>
              </div>
            </div>
                  <div v-if="personilization=='Yes'" class="personilization mb-4">
                    <h4>Personalise your order</h4>
                    <input v-model="personilizationMessage" class="personilization-msg-input" placeholder="Send us any special instructions, or the name and message you want included.">
                  </div>
                <div class="offerAvail" v-if="offersAvailable.length > 0">
                  <h4 v-if="price>=3000">
                    <img src="img/offerIcon.png" class="img-responsive" alt="" />
                    <span class="text-logo-color pl-2">{{
                      offersAvailable.length+1
                    }}</span>
                    Offers Available
                  </h4>
                  <h4 v-else>
                    <img src="img/offerIcon.png" class="img-responsive" alt="" />
                    <span class="text-logo-color pl-2">{{
                      offersAvailable.length
                    }}</span>
                    Offer{{ offersAvailable.length > 1 ? "s" : "" }} Available
                  </h4>
                  <ul class="cart-offer-list pl-4 my-2" v-if="price>=3000">
                    <li>
                      <p class="card-text">
                        EMI Starting From {{ minEmiprice.toFixed(2) | formatMoney }}/Month |
                        Credit Card EMI Available |
                        <span style="cursor: pointer" @click="emiOptions()"
                          ><strong>View Plan</strong></span
                        >
                      </p>
                   </li> 
                  </ul>
                  <ul class="cart-offer-list pl-4 my-2">
               
                    <li v-if="showAllOffers == false">
                      {{ offersAvailable[0].display_message }}-<strong>{{
                        offersAvailable[0].coupon_code
                      }}</strong>
                    </li>
                    <span v-show="showAllOffers">
                      
                      <li
                        v-for="(item, index) in offersAvailable"
                        :key="`offers-${index}`"
                      >
                        {{ item.display_message }}-<strong>{{
                          item.coupon_code
                        }}</strong>
                      </li>
                    </span>
                  </ul>
                    <a
                      v-if="showAllOffers == false && offersAvailable.length > 1"
                      @click="showAllOffers = true"
                      href="javascript:void(0)"
                      class="text-logo-color"
                    >
                      View All Offers <i class="fa fa-angle-down"></i
                    ></a>
                    <a
                      v-if="showAllOffers == true && offersAvailable.length > 1"
                      @click="showAllOffers = false"
                      href="javascript:void(0)"
                      class="text-logo-color"
                    >
                      Show Less <i class="fa fa-angle-up"></i
                    ></a>
                </div>
            <div class="add-to-cart-btns" v-if="product_type == 'gift'">
              <button
                type="button"
                v-ripple
                class="buy-now btn mobile-100"
                id="buy-now"
                title="gift"
                @click="gift_add_to_cart($event)"
              >
                Pay Now
              </button>
            </div>
          </div>
          <!-- <div class="check-delivery" v-if="product_type!='gift'">
                        <label>Check delivery in your area</label>
                        <div class="control">
                            <input type="text" maxlength="6" v-model="pincode" @keyup="pin_code" class="input-text"
                                placeholder="Enter pincode">
                            <p class="pin-success-msg" v-html="this.pincode_success" v-if="this.pincode_success != ''">
                            </p>
                            <p class="pin-error-msg" v-html="this.pincode_error" v-if="this.pincode_error != ''"></p> -->
          <!--input type="button" class="button" value="check"-->
          <!-- </div>
                    </div> -->
          <div class="detailContainer">
            <h3 class="productsHighlight">Product highlights</h3>
            <div class="highlights">
              <p class="highlight">
                <img src="/img/assure.png" width="18px" />
                100% Orginal
              </p>
              
              <p
                class="highlight"
                v-if="delivery_partner != '' && delivery_partner != null"
              >
                <img src="/img/assure.png" width="18px" />
                Delivery Partner
              </p>
              <p class="highlight" v-if="isCod">
                <img src="/img/assure.png" width="18px" />
                Cash on Delivery Available
              </p>
<!--              <p class="highlight" v-if="isPod">-->
<!--                <img src="/img/assure.png" width="18px" />-->
<!--                Pay on Delivery Available-->
<!--              </p>-->
              <p class="highlight">
                <img src="/img/assure.png" width="18px" />
                Inclusive of all taxes
              </p>
              <p class="highlight" v-if="delivery_time">
                <img src="/img/delivery-man.png" width="18px" />
                {{this.delivery_time}}
              </p>
              <!-- <p class="highlight" v-if="MinimumDeliveryTime !== ''">
                <img src="/img/shipping.png" width="18px" />
                Get it as soon as in {{ MinimumDeliveryTime }}
              </p> -->
              <!-- <p class="highlight">
                <img src="/img/rate.png" width="18px" />
                COD Available
              </p> -->
              <!-- <p class="highlight" v-if="ReturnTime !== ''">
                <img src="/img/return.png" width="18px" />
                Easy {{ ReturnTime }} returns {{ exchangeable_period }}
              </p> -->
            </div>

            <div class="leftInfoSection">
              <h2>Product Information</h2>
              <div class="detailContent">
                <h3>Description</h3>
                <p>{{ description }}</p>
              </div>
              <!-- <div v-if="weight" class="detailContent">
                <h3>Weight </h3>
                <p>{{ weight  }}</p>
              </div> -->
              <div class="detailContent">
                <h3>Product Details</h3>
                <div class="">
                  <div class="detailProduct info_lefts">
                    <ul>
                      <li v-for="(attr, index) in visibleAttrNew" :key="index">
                        <span class="label font-medium"
                          ><strong>{{ attr.label }}</strong></span
                        >
                        <span class=""
                          ><span>{{ attr.value }}</span></span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-show="howToUse" class="detailContent">
                <h3>How to Use</h3>
                <p>
                  {{ howToUse }}
                </p>
                
              </div>
              <div v-show="howToUse" class="detailContent">
                <h3>Ingredients</h3>
                <p>
                  {{ ingredients }}
                </p>
                 
              </div>
              <div class="detailContent">
                <h3>Shipping & Return Policy</h3>
                <p>
                  {{ return_policy }}
                </p>
                <a
                  href="#"
                  @click.prevent="openModel"
                  :class="return_policyCMS != '' ? '' : 'd-none'"
                  ><strong>Read Complete Store Policy</strong></a
                >
              </div>
              <div class="detailContent">
                <h3>Sold By</h3>
                <router-link
                  :to="{ path: '/store.html', query: { store: storeId } }"
                >
                  {{ this.storeName.replace(/"/g, "") }}
                  <!--<br />
								 <div
									class="brandBg"
									:style="`background-image:url(${storeImage})`"
								></div> -->
                  <!-- <img :src="storeImage" /> -->
                </router-link>
              </div>
            </div>

            <div class="moreSellers" v-if="seeOtherBuying.length > 0">
              <h4>Other Sellers</h4>
              <span v-if="moreSellersDrop == false">
                <!-- {{seeOtherBuying}} -->
                <div
                  class="sellersBox"
                  v-for="(store, i) in seeOtherBuying"
                  :key="i"
                  v-if="i < indexOfOptions"
                >
                  <!-- {{store}} -->
                  <div class="priceBtn">
                    <span>{{ store.selling_price | formatMoney }}</span>
                    <router-link
                      @click.native="getprodetail"
                      class="moreStoreRow"
                      :to="{
                        name: 'detail',
                        params: {
                          pro_id: store.id_product,
                          pro_url_key: store.url_key,
                        },
                        query: { store: store.store, id: store.id_product },
                      }"
                      >View</router-link
                    >
                    <!-- <button > Add to Cart </button> -->
                  </div>
                  <p>Sold By: {{ store.store_name }}<span> </span></p>
                  <!-- <p>{{store.size}}</p> -->
                </div>
                <p
                  style="color: var(--main-color); cursor: pointer"
                  class="text-center"
                  v-if="indexOfOptions == 2 && seeOtherBuying.length > 2"
                  @click.prevent="other_seller_popup_show" 
                >
                  View More
                </p>
                <!-- <p
                  style="color: var(--main-color); cursor: pointer"
                  class="text-center"
                  v-else
                  @click="indexOfOptions = 2"
                >
                  View Less
                </p> -->
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row container-fluid pr-0 d-none">
      <div class="detailTabs">
        <div
          class="detailTab"
          :class="{ active: activeTab == 'des' }"
          @click="activeTab = 'des'"
        >
          Description
        </div>
        <div
          class="detailTab"
          :class="{ active: activeTab == 'add' }"
          @click="activeTab = 'add'"
        >
          Additional Information
        </div>
        <!-- <div
					class="detailTab"
					:class="{ active: activeTab == 'abt' }"
					@click="activeTab = 'abt'"
				>
					About
				</div> -->
        <div
          class="detailTab"
          :class="{ active: activeTab == 'rev' }"
          @click="activeTab = 'rev'"
        >
          Reviews
        </div>
        <!-- <div
					class="detailTab"
					:class="{ active: activeTab == 'shi' }"
					@click="activeTab = 'shi'"
				>
					Shipping & Returns
				</div> -->
      </div>
      <div class="detailContent" v-if="activeTab == 'des'">
        {{ description }}
      </div>
      <div
        class="detailContent product-detail-container"
        v-if="activeTab == 'add'"
      >
        <table>
          <tr class="p-2" v-for="(data, i) in visibleAttributes" :key="i">
            <td class="p-2">
              <strong> {{ data.code }}: </strong>
            </td>
            <td class="p-2">{{ data.value }}</td>
          </tr>
        </table>
      </div>
      <div
        class="detailContent"
        v-if="activeTab == 'abt'"
        v-html="about.content"
      ></div>

      <div
        class="detailContent"
        v-if="activeTab == 'shi'"
        v-html="shipping.content"
      ></div>
    </div>
    <!--team up with product start-->
    <div
      class="text-center product-slider container-fluid"
      v-if="this.team_up_products.length"
    >
      <div class="row">
        <div class="carousel slide w-100">
          <h2 class="section-heading font-bold">TEAM UP WITH</h2>
          <slick ref="slickthree" :options="slickOptions3">
            <div
              class="p-3"
              v-for="(article, index) of team_up_products"
              :key="index"
            >
              <div class="slide-box">
                <div class="product-box">
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  >
                   <responsive-image
              
                    :alt="article.name"
                    :title="article.name"
                   
                    v-bind:desktop="`${$root.image_url_c}inside/470x470/${article.image}`"
                    v-bind:tab="`${$root.image_url_c}inside/470x470/${article.image}`"
                    v-bind:mobile="`${$root.image_url_c}inside/470x470/${article.image}`"
                    v-bind:default_image="`${$root.image_url_c}inside/470x470/${article.image}`"
                  
                  
                     />
                   
                  </router-link>
                </div>
                <p>
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                    v-text="article.name"
                  ></router-link>
                </p>
                <!-- v-if="article.selling_price != article.price" -->
                <div class="price">
                  <p>
                    <span class="price">{{
                      article.selling_price | formatMoney
                    }}</span>
                    <span
                      class="old-price"
                      v-if="article.selling_price != article.price"
                      >{{ article.price | formatMoney }}</span
                    >
                    <span
                      v-if="article.selling_price != article.price"
                      class="discount_percent font-bold"
                    >
                     {{ $root.percentOff(article.price,article.selling_price)}}</span
                    >
                  </p>
                </div>
                <!-- <div class="price" v-else>
                                    <p><span class="price" v-text="'Rs. '+article.selling_price"></span></p>
                                </div> -->
              </div>
            </div>
          </slick>
        </div>
      </div>
    </div>
    <!--team up with product end-->
    <!--you_may_also_like product start-->
    <div
      class="text-center product-slider container-fluid"
      v-if="this.you_may_also_like.length"
    >
      <div class="row">
        <div class="carousel slide w-100">
          <h2 class="section-heading font-bold">YOU MAY ALSO LIKE</h2>
          <slick ref="slickfive" :options="slickOptions3">
            <div class="p-3" v-for="article of you_may_also_like">
              <div class="slide-box">
                <div class="product-box">
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  >
                     <responsive-image
              
                    :alt="article.name"
                    :title="article.name"
                   
                    v-bind:desktop="`${$root.image_url_c}inside/470x470/${article.image}`"
                    v-bind:tab="`${$root.image_url_c}inside/470x470/${article.image}`"
                    v-bind:mobile="`${$root.image_url_c}inside/470x470/${article.image}`"
                    v-bind:default_image="`${$root.image_url_c}inside/470x470/${article.image}`"
                  
                  
                     />
                  </router-link>
                </div>
                <p>
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                    v-text="article.name"
                  ></router-link>
                </p>
                <div
                  class="price"
                  v-if="article.selling_price != article.price"
                >
                  <p>
                    <span class="old-price">{{
                      article.price | formatMoney
                    }}</span>
                    <span class="price">{{
                      article.selling_price | formatMoney
                    }}</span>
                    <span
                      v-if="article.selling_price != article.price"
                      class="discount_percent font-bold"
                    >
                     {{ $root.percentOff(article.price,article.selling_price)}}</span
                    >
                  </p>
                </div>
                <div class="price" v-else>
                  <p>
                    <span class="price">{{
                      article.selling_price | formatMoney
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </div>
    <!--you_may_also_like product end-->

    <!--similar_products product start-->
    <div
      class="text-center product-slider container-fluid"
      v-if="this.similar_products.length"
    >
      <div class="row">
        <div class="carousel slide w-100">
          <h2 class="section-heading font-bold recentView">SIMILAR PRODUCTS</h2>
          <slick ref="slickfour" :options="slickOptions3">
            <div class="p-3" v-for="article of similar_products">
              <div class="slide-box">
                <div class="product-box">
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  >
                    <!-- <div
                            class="product_image"
                            :style="{
                              backgroundImage: `url(${article.image})`,
                            }"
                          ></div> -->
                          
                   
                       <responsive-image
              
                        :alt="article.name"
                        :title="article.name"
                      
                        v-bind:desktop="`${$root.image_url_c}inside/250x250/${article.image}`"
                        v-bind:tab="`${$root.image_url_c}inside/250x250/${article.image}`"
                        v-bind:mobile="`${$root.image_url_c}inside/250x250/${article.image}`"
                        v-bind:default_image="`${$root.image_url_c}inside/250x250/${article.image}`"
                      class="new_product_image"
                  
                     />
                  </router-link>
                  <div class="viewDetails">
                    <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  > 
                    View Details
                  </router-link> 
                  </div>
                </div>
                <p>
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                    v-text="article.name"
                  ></router-link>
                </p>
                <div
                  class="price"
                  v-if="article.selling_price != article.price"
                >
                  <p>
                    <span class="old-price">{{
                      article.price | formatMoney
                    }}</span>
                    <span class="price font-weight-bold">{{
                      article.selling_price | formatMoney
                    }}</span>
                    <span
                      v-if="article.selling_price != article.price"
                      class="discount_percent font-bold"
                    >
                   {{ $root.percentOff(article.price,article.selling_price)}}</span
                    >
                  </p>
                </div>
                <div class="price" v-else>
                  <p>
                    <span class="price font-weight-bold">{{
                      article.selling_price | formatMoney
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </div>
    <!--similar_products product end-->
    <!--recent product start-->
    <div
      class="text-center product-slider container-fluid"
      v-if="this.recent_products.length"
    >
      <div class="row">
        <div class="carousel slide w-100">
          <h2 class="section-heading font-bold recentView">RECENTLY VIEWED</h2>
          <slick ref="slicksix" :options="slickOptions3">
            <div class="p-3" v-for="article of recent_products">
              <div class="slide-box">
                <div class="product-box">
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  >
                    <responsive-image
              
                    :alt="article.name"
                    :title="article.name"
                   
                    v-bind:desktop="`${$root.image_url_c}inside/250x250/${article.image}`"
                    v-bind:tab="`${$root.image_url_c}inside/250x250/${article.image}`"
                    v-bind:mobile="`${$root.image_url_c}inside/250x250/${article.image}`"
                    v-bind:default_image="`${$root.image_url_c}inside/250x250/${article.image}`"
                   class="new_product_image"
                  
                     />
                  
                  </router-link>
                  <div class="viewDetails">
                    <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  >
                    View Details
                  </router-link>
                    
                  </div>
                </div>
                <p>
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                    v-text="article.name"
                  ></router-link>
                </p>
                <div
                  class="price"
                  v-if="article.selling_price != article.price"
                >
                  <p>
                    <span class="old-price">{{
                      article.price | formatMoney
                    }}</span>
                    <span class="price font-weight-bold">{{
                      article.selling_price | formatMoney
                    }}</span>
                    <span
                      v-if="article.selling_price != article.price"
                      class="discount_percent font-bold"
                    >{{ $root.percentOff(article.price,article.selling_price)}}</span
                    >
                  </p>
                </div>
                <div class="price" v-else>
                  <p>
                    <span class="price font-weight-bold">{{
                      article.selling_price | formatMoney
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </div>
    <!--recent product end-->
    <!--top sellers products product start-->
    <div
      class="text-center product-slider container-fluid"
      v-if="this.top_sellers.length"
    >
      <div class="row">
        <div class="carousel slide w-100">
          <h2 class="section-heading font-bold">TOP SELLERS</h2>
          <slick ref="slickseven" :options="slickOptions3">
            <div class="p-3" v-for="article of top_sellers">
              <div class="slide-box">
                <div class="product-box">
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                  >
                     <responsive-image
              
                    :alt="article.name"
                    :title="article.name"
                   
                    v-bind:desktop="`${$root.image_url_c}inside/250x250/${article.image}`"
                    v-bind:tab="`${$root.image_url_c}inside/250x250/${article.image}`"
                    v-bind:mobile="`${$root.image_url_c}inside/250x250/${article.image}`"
                    v-bind:default_image="`${$root.image_url_c}inside/250x250/${article.image}`"
                 
                  
                     />
                  </router-link>
                </div>
                <p>
                  <router-link
                    :to="{
                      name: 'detail',
                      params: {
                        pro_id: article.id_product,
                        pro_url_key: article.url_key,
                      },
                      query: { store: article.store },
                    }"
                    v-text="article.name"
                  ></router-link>
                </p>
                <div
                  class="price"
                  v-if="article.selling_price != article.price"
                >
                  <p>
                    <span class="old-price">{{
                      article.price | formatMoney
                    }}</span>
                    <span class="price">{{
                      article.selling_price | formatMoney
                    }}</span>
                    <span
                      v-if="article.selling_price != article.price"
                      class="discount_percent font-bold"
                    >
                     {{ $root.percentOff(article.price,article.selling_price)}}</span
                    >
                  </p>
                </div>
                <div class="price" v-else>
                  <p>
                    <span class="price">{{
                      article.selling_price | formatMoney
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </div>

    <!--top sellers products product end-->
    <!--customer review start here-->
    <div class="container-fluid"> 
    <div class="row">
      <h2 class="section-heading font-bold pl-3">RATINGS & REVIEWS</h2>

      <div class="row w-100 d-none">
        <div class="col-md-6 m-auto">
          <form @submit="customer_review">
            <label class="w-100">Your rating *</label>
            <div class="stars">
              <input
                class="star star-5"
                id="star-5"
                type="radio"
                value="5"
                v-model="rating.star"
                name="star"
                required
              />
              <label class="star star-5" for="star-5"></label>
              <input
                class="star star-4"
                id="star-4"
                type="radio"
                value="4"
                v-model="rating.star"
                name="star"
                required
              />
              <label class="star star-4" for="star-4"></label>
              <input
                class="star star-3"
                id="star-3"
                type="radio"
                value="3"
                v-model="rating.star"
                name="star"
                required
              />
              <label class="star star-3" for="star-3"></label>
              <input
                class="star star-2"
                id="star-2"
                type="radio"
                value="2"
                v-model="rating.star"
                name="star"
                required
              />
              <label class="star star-2" for="star-2"></label>
              <input
                class="star star-1"
                id="star-1"
                type="radio"
                value="1"
                v-model="rating.star"
                name="star"
                required
              />
              <label class="star star-1" for="star-1"></label>
            </div>
            <label class="w-100">Title *</label>
            <input
              type="text"
              class="w-100 form-control"
              v-model="rating.title"
              required
            />
            <label class="w-100 mt-3">Your review *</label>
            <textarea
              class="w-100 form-control"
              v-model="rating.review"
              required
            ></textarea>
            <button type="submit" class="review-submit">Submit</button>
          </form>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
        <p class="noReviews" v-if="!reviews.reviews.length && reviews != ''">
          There are no reviews yet.
        </p>
        <div v-else class="my-5">
          <a href="#review"
            class="reviews-click font-bold">
            <span
              class="reviewStar"
             
              :class="{
                red: reviews.average_rating == 1,
                orange: reviews.average_rating == 2,
              }"
              >{{ reviews.average_rating }} <i class="fa fa-star"></i
            ></span>
            in {{ reviews.total_review }} Reviews</a>
        </div>
        <div
          v-if="reviews.reviews.length && reviews != ''"
          class="row reviews-container"
        >
          <div class="container" id="review"></div>

          <div class="col-md-12 reviewBox" v-for="(item, i) in reviews.reviews" :key="i">
            <div class="row">
              <!-- <div class="col-1">
                <img
                  src="img/reviewUserIcon.png"
                  style="
                    color: #a2a2a2;
                    width: 35px;
                    height: 35px;
                    background-color: #f8f8f8;
                    text-align: center;
                    line-height: 35px;
                    border-radius: 50px;
                    padding: 8px;
                  "
                />
              </div> -->
              <div class="col-12">
                
                <p class="title my-1">
                  <span
                    class="reviewStar"
                    :class="{
                      red: item.rr_rating == 1,
                      orange: item.rr_rating == 2,
                    }"
                    >{{ item.rr_rating }} <i class="fa fa-star"></i>
                  </span>
                  {{ item.rr_title }}
                </p>
                <p class="description">{{ item.rr_description }}</p>
                <p class="name mb-1">
                  {{ item.rr_customer_name }}
                  <!-- <small
                    style="
                      border: 1px solid var(--discount-color);
                      padding: 3px 10px;
                      color: var(--discount-color);
                      border-radius: 50px;
                      margin-left: 10px;
                    "
                    >Verified</small> -->
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </div>
        </div>  
      </div> 
      
    </div>
    </div>
    <!--customer review end here-->
    <!-- <div
			class="modal"
			v-bind:class="{ active: this.isSeeOther === true }"
			id="coupon-modal"
			v-if="this.isSeeOther"
		>
			<div class="modal-dialog" style="max-width: 530px">
				<div class="modal-content">
					<div class="modal-body">
					
						<button
							type="button"
							class="close"
							@click="toggleSeeOtherBuying()"
							style="
								margin-top: 0px;
								margin-right: 15px;
								z-index: 999;
								position: absolute;
								top: 40px;
								right: 0;
							"
						>
							&times;
						</button>
						<div class="moreStoresList">
							<h3>{{ this.seeOtherBuying.length }} Sellers Available</h3>
						
							<div
								class="row moreStoreRow"
								v-for="(store, i) in seeOtherBuying"
								:key="i"
							>
								<div class="col-4">
									<router-link
										:to="{ path: '/store.html', query: { store: store.store } }"
									>
										{{ store.store_name }}
									</router-link>
								</div>
								<div class="col-4 text-center">
									<p class="price">Rs .{{ store.selling_price }}</p>
								</div>
								<div class="col-4">
									<router-link  :to="{name:'detail', params:{ pro_id: store.id_product, pro_url_key:store.url_key},
                                                query: { store: store.store,
                                                id:store.id_product
                                                 }
                                                }"
										class="add-to-cart btn"
										
									>
										<i class="fa fa-eye mr-2" aria-hidden="true"></i>
									View
									</router-link>
								</div>
							</div>
						</div>

						    
					
					</div>
				</div>
			</div>
		</div> -->
    <!-- other sellers popup -->
       <div :class="`modal ${other_seller_popup? 'active': ''}`"  id="coupon-modal"  >
         <div class="overFlow" @click="other_seller_close_popup()"></div> 
		<div class="modal-dialog " >
			<div class="modal-content">
				<div class="modal-body">
					<!-- class="close" -->
					<button
						type="button"
						class="close popupClose"
						@click="other_seller_close_popup()" 
					>
						&times;
					</button>
					<div class="moreStores" >
						<h3 class="mb-4">Other Sellers</h3>
            <div class="storeScroll">
            <div
                  class="sellersBox"
                  v-for="(store, i) in seeOtherBuying"
                  :key="i"
                 
                >
                  <!-- {{store}} -->
                  <div class="priceBtn">
                    <span>{{ store.selling_price | formatMoney }}</span>
                    <router-link
                      @click.native="getprodetail"
                      class="moreStoreRow"
                      :to="{
                        name: 'detail',
                        params: {
                          pro_id: store.id_product,
                          pro_url_key: store.url_key,
                        },
                        query: { store: store.store, id: store.id_product },
                      }"
                      >View</router-link
                    >
                    <!-- <button > Add to Cart </button> -->
                  </div>
                  <p>Sold By: {{ store.store_name }}<span> </span></p>
                  <!-- <p>{{store.size}}</p> -->
                </div>

						</div>
					</div>
					<!-- <Login /> -->
				</div>
			</div>
		</div>
	</div>

<!-- Toast for new store -->
<!-- <div class="minicart-toast" v-if="this.toastMessage == true">
                <div class="block-content">
                    
                    <p>You have added an item from a different store. Shipping charges may vary accordingly. <span><button @click="toastMessageFunction">OK</button></span></p>
                </div>
            </div> -->
<!-- Toast Ends -->
<!-- other sellers popup end -->

    <!--size guide popup start here-->
    <div
    id="size-modal"
      class="modal size-guide-popup-container sizePopup "
      v-bind:class="{ active: this.size_guide_popup === true }"
     
    >
     <!-- id="coupon-modal" -->
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          
          <!-- Modal body -->
          <!-- v-html="this.size_guide_content" -->
          <div class="modal-body">
            <button type="button" class="sizePopupClose" @click="close_popup()">
              &times;
            </button>
            <div class="container-fluid">
              <div class="row productDetailRow">
                <div class="col-3">
                    <responsive-image
                    v-bind:desktop="`${$root.image_url_c}inside/450x450/${sizeChart[0].image}`"
                    v-bind:tab="`${$root.image_url_c}inside/450x450/${sizeChart[0].image}`"
                    v-bind:mobile="`${$root.image_url_c}inside/450x450/${sizeChart[0].image}`"
                    v-bind:default_image="`${$root.image_url_c}inside/450x450/${sizeChart[0].image}`"
                   class="img-fluid"

                     />

                </div>
                <div class="col-8 pl-5">
                    <h4 class="popupBrand"> {{sizeChart[0].brand}}</h4>
                    <p class="popupTitle"> {{sizeChart[0].name}}</p>
                    <div class="priceDes">
                      <p>
                        <span class="price font-medium pr-2">{{selling_price | formatMoney}}</span>
                        <span v-if="selling_price != price" class="old-price">Rs.  {{price | formatMoney}}</span>
                        <span class="discount_percent">{{$root.percentOff(price,selling_price)}}</span>
                      </p>
                    </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center error-main">
                  <div class="row">
                     <div class="sizePopupTabs">
                      <a href="#" class="sizePopupTab" @click.prevent="isSize = true"
                      v-bind:class="{ activeTab: isSize }"
                      >
                        Size Chart
                      </a>
                      <a href="#" class="sizePopupTab" @click="scrollIfImage" @click.prevent="isSize = false"  v-bind:class="{ activeTab: !isSize }">
                         How to Measure
                      </a>
                     </div>
                     <div class="w-100">
                       <div class="size-guide-con"> 
                        <button v-bind:class="{active:this.size_guide_type==='IN'}" @click="size_guide_con('IN')"
                            v-bind:disabled="(this.size_guide_type==='IN') === true">in</button>
                        <button v-bind:class="{active:this.size_guide_type==='CM'}" @click="size_guide_con('CM')"
                            v-bind:disabled="(this.size_guide_type==='CM') === true">cm</button>
                      </div>
                      </div>
                    <div class="col-12">
                      
                      <table class="table sizeChartTable">
                        <tbody v-if="this.size_guide_type==='IN'">
                          <tr>
<!--                            <td>Size</td>-->
<!--                            <td v-if="!isFootware">Size</td>-->
                            <td v-for="(item,i) in sizeChart[0].size_chart" :key="i">{{item.label}}</td>

                          </tr>
                          <tr @click="select_size(size); isSelectSizeFromChart = false" class="tableRadio " :class="{radioNotActive:(size.stock_status === 'out-of-stock' ), radioActive:(master_sku == size.sku && isSelectSizeFromChart == false && size.stock_status != 'out-of-stock' ) }" v-for="(size,i) in sizeChart"  :key="i">
<!--                        <td v-if="!isFootware">{{size.configrable_atribute_value}}</td>-->
<!--                            <td>{{size.configrable_atribute_value}}</td>-->
                            <td v-for="(item,i) in size.size_chart" :key="i">
                              <span v-if="size.stock_status === `out-of-stock`">{{item.value}}</span>
                              <span v-if="size.stock_status != `out-of-stock`">{{item.value}}</span>
                            </td>
                          </tr>
                          
                        </tbody>
                         <tbody v-else>
                          <tr>
<!--                            <td>Sizes</td>-->
<!--                            <td v-if="!isFootware">Size</td>-->
                            <td v-for="(item,i) in sizeChart[0].size_chart" :key="i">{{item.label}}</td>
                           
                          </tr>
                          <tr @click="select_size(size); isSelectSizeFromChart = false" class="tableRadio " :class="{radioNotActive:(size.stock_status === 'out-of-stock' ), radioActive:(master_sku == size.sku && isSelectSizeFromChart == false )}" v-for="(size,i) in sizeChart" :key="i">
<!--                            <td>{{size.configrable_atribute_value}}</td>-->
<!--                            <td v-if="!isFootware">{{size.configrable_atribute_value}}</td>-->
                            <td v-for="(item,i) in size.size_chart" :key="i">{{item.value_cm}}</td>
                          </tr>
                          
                        </tbody>
                      </table> 
                      <p>
                        These measurements are indicative. Actual Size may
                        differ.
                      </p>
                    </div>
                    <div v-if="this.sizeChartImage != null || this.sizeChartImage != ''" class="col-12" id="scrollwhenclicked">
                          <img src="" alt="">
                          <responsive-image
                          v-bind:desktop="`${$root.image_url_c}inside/450x450/csv_images/${this.sizeChartImage}`"
                          v-bind:tab="`${$root.image_url_c}inside/450x450/csv_images/${this.sizeChartImage}`"
                          v-bind:mobile="`${$root.image_url_c}inside/450x450/csv_images/${this.sizeChartImage}`"
                          v-bind:default_image="`${$root.image_url_c}inside/450x450/csv_images/${this.sizeChartImage}`"

                           width="100%"

                     />

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sizeCartFixBtn">
            <button class="sizeCartBtn " :class="{sizeChartDisable: isSelectSizeFromChart}"  @click="add_to_cart()"
                v-if="this.stock_status === 'in-stock'">
              <img src="/img/shoppingCart.png" alt="" style="margin-right: 10px;">
                ADD TO CART
            </button>
            <button class="sizeBuyBtn" @click="buyNow()" :class="{sizeChartDisable: isSelectSizeFromChart}"
                v-if="this.stock_status === 'in-stock'">
              <img src="/img/shoppingBag.png" alt="" style="margin-right: 10px;">
                BUY NOW
            </button>
          </div>
          </div>
          
        </div>
      </div>
    </div>
    <!-- <div class="rightFilterWrap buyingOption forDesktop" :class="{ 'showFilter' : isSeeOther }">
			<div class="rightFiterContent">
				<div class="filterHeading">
					{{ this.seeOtherBuying.length }} Sellers Available
					<a href="javascript:void(0)" class="filterClose float-right mr-3 text-dark"> &#10005;</a>
				</div>
				<div class="filterData">
					<div class="filterDataScroll">
						<div class="row">
							<div class="col-md-12" v-for="(store, i) in seeOtherBuying" :key="i" >
								<router-link class=" moreStoreRow" :to="{name:'detail', params:{ pro_id: store.id_product, pro_url_key:store.url_key},
                                                query: { store: store.store,
                                                id:store.id_product
                                                 }
                                                }">
								<p class="price">Rs .{{ store.selling_price }}</p>
								<p class="nameStore"> {{ store.store_name }} </p>								
							
								<a class="add-to-cart btn" >
										<i class="fa fa-eye mr-2" aria-hidden="true"></i>
									View
								</a>
								
								
								</router-link>
							</div> 
						</div> 
					</div>
				
				</div>
			</div>
		</div> -->

    <!--  return policy model -->
    <div
      class="modal return_model"
      v-bind:class="{ active: returnP_model == true }"
      id="coupon-modal"
      v-if="returnP_model"
    >
    <div class="overFlow" @click="returnP_model = false"></div> 
      <div class="modal-dialog listStorePopup modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <!-- class="close" -->
            <button
              type="button"
              class="close"
              @click="returnP_model = false"
              style="
                margin-top: 0px;
                margin-right: 15px;
                z-index: 999;
                top: 15px;
                right: 0px;
                font-size: 25px;
              "
            >
              &times;
            </button>
            <div>
              <div class="storePopupHeading">
                <h3>Shipping & Return Policy</h3>
              </div>
              <div class="storeWrap">
                <!-- <img :src="return_policyCMS.logo_link" alt="img" class="logo"> -->
                <p v-html="return_policyCMS.content"></p>
              </div>
            </div>
          </div>
              
        </div>
      </div>
    </div>
<!--size guide popup end here-->

<!-- start full page loader popup  -->

     <div
      class="modal"
      style="z-index: 1100"
      v-bind:class="[this.coupon_process ? 'active' : '']"
      id="coupon-modal"
    >
      <loading-icon
        class="loading-icon applyCouponloader"
        name="ball-clip-rotate-multiple"
        color="#ba2126"
        scale="1"
      ></loading-icon>
    </div>
<!-- end full page loader popup  -->

<!-- EMI coupon popup starts -->
    <div class="emi-modal" v-if="showEMIPopup">
      <div class="emi-modal-content">
        <div class="emi-modal-header">
          <h2><strong>EMI PLANS</strong></h2>
          <button class="emi-popup-close" @click="close_popup_emi()">
            &times;
          </button>
        </div>

        <div class="emi-modal-body">
          <div class="emi-details">
            <ul
             
              v-if="Object.keys(this.emiPlans).length !== 0"
              class="emi-banks-name"
            >
              <li
                v-for="(bank, index) in emiPlans"
                :key="`indx-${index}`"
                class="list-group-item"
                :class="{ active: activeEMIClass == index }"
                @click="getEmiPlansTableData(index)"
              >
                {{ index }}
              </li>
            </ul>

            <div class="emi-table-data">
              <table class="emi-table table">
                <thead>
                      <tr>
                        <th scope="col">Months</th>
                        <th scope="col">Interest</th>
                        <th scope="col">Monthly EMI</th>
                        <th scope="col">Overall Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, value) in bankPlans.plans"
                        :key="`bank-${value}`"
                      >
                        <th scope="row">{{ value }}</th>
                        <td>
                          {{ item }}% pa (Rs.
                          {{
                            EMIVal2(selling_price, item, value).interestAmount.toFixed(2)
                              | formatMoney
                          }})
                        </td>
                        <td>
                          Rs.
                          {{
                            EMIVal2(selling_price, item, value).emi.toFixed(2)
                              | formatMoney
                          }}
                        </td>
                        <td>
                          Rs.
                          {{
                            EMIVal2(selling_price, item, value).total.toFixed(2)
                              | formatMoney
                          }}
                        </td>
                      </tr>
                    </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- emi coupon popup ends -->

  </div>
</template>
<style scoped>
.return_model .storeWrap {
  height: 350px !important;
}
.return_model .storeWrap p {
  margin: 0px 10px;
}
.return_model .listStorePopup {
  max-width: 500px !important;
  margin: 0px auto;
}
.storeWrap p{
  font-size: 14px;
}
.productPagesk .Skeleton1 {
  height: 15px;
  margin-top: 5px;
  margin-bottom: 2px;
  display: block;
}
.productPageSkeleton {
  display: flex;
  gap:10px;
}
.productPageSkeleton .Skeleton2 , .productPageSkeleton .Skeleton3 {
  width: 50%;
  height: 100vh;
  display: block;


}
.productImage.forDesktop{
  min-height: 500px;
}
@media screen and (max-width:767px) {
  .productPagesk {
    width: 95%;
    margin: 0 auto;
  }
  .productPageSkeleton {
    display: block;
  }
  
  .productPageSkeleton .Skeleton2  {
  width: 100%;
  height:60vh;
  display: block;
  margin:0 auto;
  margin-bottom: 20px;
}
 .productPageSkeleton .Skeleton3 {
  width: 100%;
  height: 30vh;

 }
}
</style>



<script>
import axios from "axios";
import Slick from "vue-slick";
import { bus } from '../main.js';
import lightgallery from 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.min.css'
import 'lg-zoom.js'
//  
export default {
  name: "Product_detail",
  computed:{
    offersAvailable() {
          let offers = [];
          let storecouon=[];
          let platformcoupon=[];
          let allcoupon=[];
          if (this.coupon_list) {
           
            // for (const [key, value] of Object.entries(this.coupon_list)) {
            //   console.log("huehuehuehue",value)
            //   offers.push(...value);
            // }
            for (let key in this.coupon_list) {
                  
                 if(key=='WNDW'){
                   platformcoupon.push(...this.coupon_list[key])
                 }
                 else{
                    storecouon.push(...this.coupon_list[key])
                 }
            }
           storecouon= storecouon.reverse()
           platformcoupon=platformcoupon.reverse()
            allcoupon=[...storecouon, ...platformcoupon]
           offers.push(...allcoupon);
          }
          return offers;
        },
  },
  metaInfo() {
    return {
      title: this.meta_title,
      meta: [
        {
          name: "description",
          content: this.meta_description,
        },
        {
          property: "keywords",
          content: this.meta_keyword,
        },
      ],
    };
  },
  components: {
    Slick,
  },
  data: function () {
    return {
      personilization:null,
      personilizationMessage:'',
      ProductDetailLoader:true,
      coupon_process: false,
      minEmiprice: 0,
      showEMIPopup: false,
      emiPlans: {},

      bankPlans: {
        minAmount: 0,
        plans: { 3: 14, 6: 14, 9: 14, 12: 14, 18: 14, 24: 14 },
      },
      activeEMIClass: "",
      coupon_list:[],
      showAllOffers: false,
      // toastMessage : false,
      diffStore:false,
      isFootware: false,
      isSelectSizeFromChart : true,
      isSizeChart: false,
      isSelectableWithoutSize: false,
      isPod: false,
      weight: '',
      other_seller_popup : false,
      howToUse: '',
      ingredients: '',
      isCod: false,
      moreSellersDrop: false,
      delivery_partner: "",
      returnP_model: false,
      MinimumDeliveryTime: "",
      ReturnTime: "",
      return_policy: "",
      return_policyCMS: "",
      activeTab: "des",
      visibleAttrNew: [],
      about: "",
      shipping: "",
      store: null,
      isSeeOther: false,
      indexOfOptions: 2,
      rating: {
        star: "",
        review: "",
        title: "",
      },
      isSize:true,
      brandName: "",
      isExpressProduct: false,
      reviews: {
        reviews: []
      },
      seeOtherBuying: [],
      stores: [],
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        fade: false,
        asNavFor: ".slick-thumb",
      },
      slickOptionsImage: {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".main-slider",
        dots: false,
        centerMode: true,
        infinite: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
      },
      slickOptions1: {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".main-slider",
        dots: false,
        centerMode: true,
        infinite: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
      },
      slickOptions3: {
        slidesToShow: 5,
        arrows: false,

        responsive: [
          {
            breakpoint: 997,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "50px",
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "50px",
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },
      size: {
        select_size: "",
        max_qty: "1",
        variant_id: "",
        sku: "",
      },
      product_attr_data: {
        count: 6,
        text: "Show More",
        active: false,
      },
      meta_title: "",
      meta_description: "",
      meta_keyword: "",
      size_active: true,
      qty: "1",
      vedio: "",
      product_id: "",
      product_type: "",
      gift_email: "",
      gift_phone: "",
      gift_message: "",
      size_error: "",
      pro_id: this.$route.params.pro_id,
      pro_url_key: this.$route.params.pro_url_key,
      name: "",
      storeName: "",
      storeId: "",
      storeImage: "",
      master_sku: "",
      price: 0,
      groupId: "",
      stock_status: "",
      AvailableQuantity:'',
      product_cat: "",
      selling_price: 0,
      description: "",
      message_error: "",
      email_error: "",
      phone_error: "",
      variation: [],
      placeholder_image: "",
      gallery: [],
      offers_list: "",
      product_attr: [],
      show_hide_product_attr: [],
      styling_sug: [],
      show_hide_product_attr_type: false,
      team_up_products: [],
      you_may_also_like: [],
      similar_products: [],
      top_sellers: [],
      sizeChart:[{brand: '', name : '', image : '', size_chart: [], size_chart_image: ''

      }],
      recent: "",
      isGrocery: false,
      pdpBreadcrumb: [],
      recent_pro: "",
      recent_products: [],
      size_guide: "",
      size_guide_content: "",
      size_guide_popup: false,
      size_guide_type: "CM",
      pincode: "",
      pincode_success: "",
      isBuyNow: false,
      isAddedToCart: false,
      pincode_error: "",
      free_offer: false,
      visibleAttributes: [],
      free_offer_sku: [
        "19AUW9HB0002-43168",
        "19AUW9HB0002-43167",
        "20FEW93098-43164",
        "20FEW93098-43163",
        "20FEW93096-43087",
        "20FEW93096-43086",
        "20FEW93095-43085",
        "20FEW93094-43084",
        "20FEW93094-43083",
        "20FEW93090-43162",
        "20FEW93090-43161",
        "20FEW93089-43280",
        "20FEW93089-43159",
        "20FEW93089-43158",
        "20FEW93089-43157",
        "20FEW93089-43156",
        "20FEW93089-43155",
        "20FEW93088-43154",
        "20FEW93088-43153",
        "20FEW93087-43152",
        "20FEW93087-43151",
        "20FEW93085-43148",
        "20FEW93085-43147",
        "20FEW93084-43146",
        "20FEW93084-43145",
        "20FEW93084-43144",
        "20FEW93083-43143",
        "20FEW93083-43142",
        "20FEW93082-43141",
        "20FEW93082-43140",
        "20FEW93081-43139",
        "20FEW93081-43138",
        "20FEW93080-43170",
        "20FEW93080-43137",
        "20FEW93080-43136",
        "20FEW93078-43169",
        "20FEW93078-43134",
        "20FEW93078-43133",
        "20FEW93076-43131",
        "20FEW93075-43130",
        "20FEW93075-43129",
        "20FEW93075-43128",
        "20FEW93074-43127",
        "20FEW93074-43126",
        "20FEW93074-43125",
        "20FEW93073-43124",
        "20FEW93072-43123",
        "20FEW93072-43122",
        "20FEW93071-43121",
        "20FEW93070-43120",
        "20FEW93070-43119",
        "20FEW93070-43118",
        "20FEW93069-43117",
        "20FEW93069-43116",
        "20FEW93068-43115",
        "20FEW93067-43114",
        "20FEW93066-43113",
        "20FEW93066-43112",
        "20FEW93066-43111",
        "20FEW93065-43110",
        "20FEW93064-43109",
        "20FEW93064-43108",
        "20FEW93063-43107",
        "20FEW93062-43106",
        "20FEW93060-43104",
        "20FEW93058-43209",
        "20FEW93058-43208",
        "20FEW93058-43207",
        "20FEW93058-43206",
        "20FEW93058-43205",
        "20FEW93058-43103",
        "20FEW93058-43102",
        "20FEW93056-43100",
        "20FEW93056-43099",
        "20FEW93055-43098",
        "20FEW93055-43097",
        "20FEW93054-43096",
        "20FEW93054-43095",
        "20FEW93053-43093",
        "20FEW93053-43092",
        "20FEW93052-43091",
        "20FEW93052-43090",
        "20FEW93050-43089",
      ],
      info_array: [
        "color",
        "material",
        "fabric_content",
        "upper_material",
        "bottom_sole_material",
        "insole_material",
        "neck",
        "sleeve",
        "sleeve_styling",
        "fit",
        "shape",
        "closure",
        "slit_detail",
        "hemline",
        "waist_bands",
        "occasion",
        "length",
        "ethnicity",
        "fastening_closure",
        "closure_strap",
        "ornamentation",
        "toe_shape",
        "toe_type",
        "insole_color",
        "insole_type",
        "heel_height_inch",
        "heel_pattern",
        "texture",
        "pattern",
        "footwear_length_cm",
        "heel_type",
        "cushioning_detail",
        "material_care",
        "warranty",
        "uk_size",
        "us_size",
        "applicablility",
        "payment_mode",
        "voucher_type",
        "redeemable",
        "value",
        "validity",
        "usage",
        "tnc",
        "fabric_family",
        "foldable",
        "reusable",
        "colour_family",
        "colour_details",
        "mask_design",
        "fastening",
        "fastening_method",
        "mask_type",
        "care",
        "size_chart",
        "returnable",
      ],
      showProductImages: false,
    };
  },
  methods: {
    getCouponList() {
      let store=this.$route.query.store
         axios
        .get(this.$root.api_url + "/pim/promotions/listapi.php", {
          params: {
            type: "coupons",
            s: store,
          },
        })
        .then((res) => {
          this.coupon_list = res.data;
 
        });
    },
    
    emiOptions() {
      this.coupon_process = true;
      if (Object.keys(this.emiPlans).length === 0) {
        axios
          .get(this.$root.cart_api + "/emi/emi-options")
          .then((response) => {
            this.coupon_process = false;
            this.showEMIPopup = true;
            this.emiPlans = response.data.data.emi_plans;
            this.getEmiPlansTableData(Object.keys(this.emiPlans)[0]);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.coupon_process = false;
        this.showEMIPopup = true;
      }
    },
    close_popup_emi() {
      this.showEMIPopup = false;
    },
    getEmiPlansTableData(bank) {
      this.activeEMIClass = bank;
      this.bankPlans = {};
      this.bankPlans.plans = this.emiPlans[bank].plans;
      this.bankPlans.minAmount = this.emiPlans[bank].min_amount;
    },
    EMIVal2(loan, interestRate, time) {
      let interest = parseFloat(interestRate) / 1200;
      let term = parseInt(time);
      let top = Math.pow(1 + interest, term);
      let bottom = top - 1;
      let ratio = top / bottom;
      let emi = parseInt(loan) * interest * ratio;
      var totalAmount = emi * term;
      var interestAmount = totalAmount - parseInt(loan);
      return { emi: emi, total: totalAmount, interestAmount: interestAmount };
    },
    CloseDiffStoreCheckPopup(){
      this.diffStore=false
    },
    scrollIfImage(){
      if(this.sizeChartImage){
        document.getElementById('scrollwhenclicked').scrollIntoView(true);
      }
    },
    moresellersdrop() {
      this.moreSellersDrop = !this.moreSellersDrop;
    },

    openModel() {
      this.returnP_model = true;
    },

    toggleSeeOtherBuying() {
      // console.log("called");
      this.isSeeOther = !this.isSeeOther;
    },
    addToWishList() {
      if (!this.$root.customer_id) {
        this.$root.login_popup = true;
      } else {
        // console.log("called else");
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("type", "add");
        form.append("product_id", this.product_id);
        axios.post(this.$root.cart_api + `/wishlist/add-to-wishlist`, form).then((res) => {
            if (res.data.success) {
              this.$root.wishListProducts = this.$root.wishListProducts + 1;
              this.$toast.success(res.data.message, {
                position: "top-right",
                duration: 4000,
              });
            } else {
              this.$toast.error(res.data.message, {
                position: "top-right",
                duration: 4000,
              });
            }
          })
          .catch((err) => {
            this.$toast.error("Something went wrong", {
              position: "top-right",
              duration: 4000,
            });
            //this.$root.error_message = err.data.message
          });
      }
      // console.log(id);
    },
    get_size_chart() {
      axios
        .get(
          this.$root.api_url +
            `/pim/pimresponse.php?service=cms_page&url_key=${this.size_guide}&store=${this.$root.store}`
        )
        .then((response) => {
          if (response.data.response.success == 1) {
            // console.log(response.data.result[0].content);
            this.size_guide_content = response.data.result[0].content;
          }
        });
    },
    get_review() {
      var form = new FormData();
      form.append("master_sku", this.master_sku);
      form.append("store", this.$root.store);
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      axios
        .post(this.$root.cart_api + "/review/review-list", form, config)
        .then((response) => {
          if (response.data.success == true) {
            this.reviews = response.data.data;
          }
        });
    },
    customer_review(e) {
      e.preventDefault();
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("master_sku", this.master_sku);
        form.append("store", this.$root.store);
        form.append("product_id", this.pro_id);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("title", this.rating.title);
        form.append("description", this.rating.review);
        form.append("rating", this.rating.star);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
          .post(this.$root.cart_api + "/review/add-review", form, config)
          .then((response) => {
            this.$root.page_loader = false;
            if (response.data.success == true) {
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
              this.rating.title = "";
              this.rating.star = "";
              this.rating.review = "";
            } else {
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
              if (response.data.customer_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/login.html");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
          });
      } else {
        this.$root.login_popup = true;
      }
    },
    gift_email_f: function () {
      var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.gift_email.match(email)) {
        this.email_error = "";
      } else {
        this.email_error = "Please enter valid Email";
      }
    },
    gift_message_f: function () {
      var name = /^(?!\s*$).+/;
      if (this.gift_message.match(name)) {
        this.message_error = "";
      } else {
        this.message_error = "Please enter Message";
      }
    },
    gift_phone_f: function () {
      var phoneno = /^([0-9]{10,})+$/;
      if (this.gift_phone.match(phoneno)) {
        this.phone_error = "";
      } else {
        this.phone_error = "Please enter valid Phone Number";
      }
    },
    product_attr_show_hide() {
      if (this.product_attr_data.active == false) {
        this.product_attr_data.count = this.product_attr.length;
        this.product_attr_data.active = true;
        this.product_attr_data.text = "Hide More";
        this.show_hide_product_attr_type = true;
      } else {
        this.product_attr_data.count = 6;
        this.product_attr_data.active = false;
        this.product_attr_data.text = "Show More";
        this.show_hide_product_attr_type = false;
      }
    },
    more_info_show: function () {
      this.show_hide_product_attr_type = true;
    },
    more_info_hide: function () {
      this.show_hide_product_attr_type = false;
    },
    pin_code: function () {
      let pincode = /^([0-9]{6,})+$/;
      if (this.pincode.match(pincode)) {
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "pincheck",
              store: this.$root.store,
              pincode: this.pincode,
            },
          })
          .then((response) => {
            if (response.data.response.success === "1") {

              if (response.data.result.type == "N") {
                this.pincode_error =
                  "<span class='error'>Sorry this pincode is not serviceable.</span>";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_pin",
                  this.pincode
                );
                this.pincode_success = "";
              } else {
                this.pincode_success = response.data.response.success_message;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_pin",
                  this.pincode
                );
                this.pincode_error = "";
              }
            } else {
              this.pincode_error = response.data.response.error_message;
              this.pincode_success = "";
            }
          });
      } else {
        this.pincode_error =
          "<span class='error'>Please enter valid Pin code</span>";
        this.pincode_success = "";
      }
    },
    size_guide_con(type) {
      this.size_guide_type = type;
      let size_val = document.getElementsByClassName("size-changetd");
      for (let i = 0; i < size_val.length; i++) {
        if (type === "CM") {
          let cur_size = (size_val[i].innerHTML * 2.54).toFixed(2);
          size_val[i].innerHTML = cur_size;
        } else {
          let cur_size = (size_val[i].innerHTML / 2.54).toFixed(0);
          size_val[i].innerHTML = cur_size;
        }
      }
    },
    qty_plus() {
      if (this.size.select_size != "") {
        this.$root.error_message = "";
        this.$root.success_message = "";
        if (this.qty < this.size.max_qty && this.qty < 5) {
          this.qty = this.qty * 1 + 1;
        }
      } else {
        this.size_active = false;
        this.size_error = "Please select a size first";
      }
    },
    qty_minus() {
      if (this.size.select_size != "") {
        this.$root.error_message = "";
        this.$root.success_message = "";
        if (this.qty > 1) {
          this.qty = this.qty * 1 - 1;
        }
      } else {
        this.size_active = false;
        this.size_error = "Please select a size first";
      }
    },

    other_seller_popup_show() {
      this.other_seller_popup = true;
    },
    other_seller_close_popup() {
      this.other_seller_popup = false;
    },


    size_popup_show() {
      this.size_guide_popup = true;
    },
    close_popup() {
      this.size_guide_popup = false;
    },
    getSizeChart (){
       axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
         
          params: {
            service: "sizechart",
            store: this.$route.query.store,
            url_key: this.pro_url_key,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        }).then(
          response =>{
            // console.log(response.data.result[0].is_footwear);
            // console.log("In Get Size Chart");
            // console.log(response.data.result);
            this.sizeChart = response.data.result
          }
        ).catch(error =>
       {
         console.log(error);
       })
    },
    getprodetail() {
      
    window.scrollTo(0,0);
     
      this.other_seller_popup = false;
      this.isAddedToCart = false;
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.$root.page_loader = true;
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "product",
            store: this.$route.query.store,
            url_key: this.pro_url_key,
            recent_views_products: this.recent,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        })
        .then((response) => {
          this.$root.page_loader = false;
          if (response.data.response.success == 1) {
            this.$root.error_message = ''
            // console.log("returmss",response.data.result.visible_attributes[7]);
            this.visibleAttributes = response.data.result.visible_attributes;
            this.delivery_partner = response.data.result.variation.delivery_partner;
            this.return_policy = response.data.result.returns_policy;
            if (response.data.result.size_chart) {
              this.isSizeChart = response.data.result.size_chart
              // this.size_guide = response.data.result.size_chart.key;
              // this.get_size_chart();
            }
            this.personilization=response.data.result.personalization_message
          
            this.about = response.data.result.about;
            this.seeOtherBuying = response.data.result.other_buying_options;
            this.seeOtherBuying.map((item) => {this.stores.push(item.store)});
            this.code = response.data.result.configrable_atribute_code;
            let atr = response.data.result.visible_attributes;
            let index = atr.findIndex((e) => {if (e.code == this.code) return e;});
            if (index > 0) {this.label = atr[index].label;}
            

            if (response.data.result.configrable_atribute_value == null && response.data.result.size == null
            ) {
              this.isSelectableWithoutSize = true;
            } else {
              this.isSelectableWithoutSize = false;
            }
            this.goupId = response.data.result.group_id;
            this.shipping = response.data.result.shipping;
            this.product_id = response.data.result.id_product;
            this.sku = response.data.result.sku;
            this.storeName = response.data.result.store_name;
            this.AvailableQuantity = response.data.result.quantity
            this.stock_status = response.data.result.stock_status;
            this.storeId = response.data.result.store;
            this.storeImage = response.data.result.store_image;
            this.$metaInfo.title = response.data.result.name;
            this.$root.breadcrumb = response.data.result.name;
            this.name = response.data.result.name;
            this.product_type = response.data.result.product_type;
            this.meta_title = response.data.result.meta_title;
            this.meta_description = response.data.result.meta_description;
            this.meta_keyword = response.data.result.meta_keyword;
            this.pro_id = response.data.result.id_product;
            this.master_sku = response.data.result.sku;
            this.store = response.data.result.store;
            this.isGrocery = response.data.result.is_grocery ? 1 : 0;
            this.brandName = response.data.result.brand;
            this.pdpBreadcrumb = response.data.result.breadcrumb;
            this.isExpressProduct = response.data.result.express_store ? response.data.result.express_store.is_express_delivery_available : 0; 

           
            if (this.recent != null) {
              this.recent_pro = this.recent.split(",");
              var found = false;
              if (this.recent_pro.length == 5) {
                this.recent_pro.splice(4, 1);
                this.recent = Array.prototype.map
                  .call(this.recent_pro, (s) => s)
                  .toString();
              }
              for (let i = 0; i < this.recent_pro.length; i++) {
                if (this.recent_pro[i] == this.master_sku) {
                  found = true;
                  break;
                }
              }
              if (found === false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_recent",
                  response.data.result.sku + "," + this.recent,
                  "1y"
                );
              }
            } else {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_recent",
                response.data.result.sku,
                "1y"
              );
            }

            this.price = response.data.result.price;
            this.product_cat = response.data.result.category;
            this.selling_price = response.data.result.selling_price;
            this.delivery_time = response.data.result.delivery_in_text;
            this.sizeChartImage = response.data.result.size_chart_image;
            this.description = response.data.result.description;
            console.log('selling_price', this.selling_price)
            this.variation = response.data.result.variation;
            if (response.data.result.variation.length == 1) {
              setTimeout(
                () => document.querySelector(".select-one-size").click(),
                100
              );
            }
            this.placeholder_image = response.data.result.image;
            this.gallery = response.data.result.gallery;
            this.showProductImages = true;
            for (let i = 0; i < response.data.result.gallery.length; i++) {
              if (response.data.result.gallery[i].vedio == "true") {
                this.vedio = response.data.result.gallery[i].image;
              }
            }
           setTimeout(() => lightGallery(document.getElementById('lightgallery'),
                    {
                        download: false,
                        closable: false,
                        selector: 'img'
                    }), 100);

            // setTimeout(() => {
            //   this.startImageZoom();
            // }, 1000);

            //this.product_attr = response.data.result.visible_attributes;
            if (response.data.result.visible_attributes.length != 0) {
              // this.visibleAttrNew = response.data.result.visible_attributes
              this.visibleAttrNew = response.data.result.visible_attributes.filter(
                (attr) =>
                  attr.code !== "returns_policy" &&
                  attr.code !== "manufacturer_name" &&
                  attr.code !== "cash_on_delivery" &&
                  attr.code !== "gross_weight" &&
                  attr.code !== "unit_of_measure" &&
                  attr.code !== "ingredients" &&
                  attr.code !== "how_to_use"  &&
                
                  attr.code !== "pay_on_delivery"
              );
              

              let returnIndex = response.data.result.visible_attributes.findIndex(
                (e) => {
                
                  if (e.code == "returns_policy") {
                    return e;
                  }
                }
              );
             
              let codIndex = response.data.result.visible_attributes.findIndex(
                (e) => {
                  if (e.code == "cash_on_delivery") {
                    return e;
                  }
                }
              );
              let podIndex = response.data.result.visible_attributes.findIndex(
                (e) => {
                  if (e.code == "pay_on_delivery") {
                    return e;
                  }
                }
              );
              if (codIndex) {
                this.isCod = true;
              } else {
                this.isCod = false;
              }
              if(podIndex) {
                this.isCod = false;
                this.isPod = true 
              } else {
                 this.isPod = true 

              }
              this.returnPolicies =
                response.data.result.visible_attributes[returnIndex];
              // console.log("returnIndex", returnIndex);
               var unitOfMeasure ='', grossWeight= '' 
              for (let i = 0; i < this.info_array.length; i++) {
                for (
                  var e = 0;
                  e < response.data.result.visible_attributes.length;
                  e++
                ) {
                  if (
                    this.info_array[i] ==
                    response.data.result.visible_attributes[e].code
                  ) {
                    this.product_attr.push(
                      response.data.result.visible_attributes[e]
                    );
                  }
                }
              }
              for (
                let j = 0;
                j < response.data.result.visible_attributes.length;
                j++
              ) {
                 switch (response.data.result.visible_attributes[j].code) {
                    case "gross_weight":
                      grossWeight = response.data.result.visible_attributes[j].value;
                      break;
                    case "unit_of_measure":
                      unitOfMeasure = response.data.result.visible_attributes[j].value;
                      break;
                    case "how_to_use":
                      this.howToUse = response.data.result.visible_attributes[j].value;
                      break;
                    case "ingredients":
                      this.ingredients = response.data.result.visible_attributes[j].value;
                      break;
                   
                  }
                  
                 
                  
                  // if ( response.data.result.visible_attributes[i] == "How To Use") {
                  //   this.howToUse =  e.value
                  // }
                  // if ( response.data.result.visible_attributes[i] == "Ingredients") {
                  //    this.ingredients =  e.value
                  // }
                if (
                  response.data.result.visible_attributes[j].code ===
                    "marked_by" ||
                  response.data.result.visible_attributes[j].code ===
                    "quantity_show" ||
                  response.data.result.visible_attributes[j].code ===
                    "name_of_manufacturer" ||
                  response.data.result.visible_attributes[j].code ===
                    "place_of_manufacturer" ||
                  response.data.result.visible_attributes[j].code ===
                    "registered_office_address" ||
                  response.data.result.visible_attributes[j].code ===
                    "manufactured_packed_for" ||
                  response.data.result.visible_attributes[j].code ===
                    "for_complaints"
                ) {
                  this.show_hide_product_attr.push(
                    response.data.result.visible_attributes[j]
                  );
                }
                if (
                  response.data.result.visible_attributes[j].code ===
                  "styling_suggestion"
                ) {
                  this.styling_sug.push(
                    response.data.result.visible_attributes[j]
                  );
                }
              }
              if(grossWeight != '' && unitOfMeasure != '' ) {
                 this.weight = `${grossWeight} ${unitOfMeasure}`

              }
              
            }

            if (response.data.result.team_up_products) {
              this.team_up_products = response.data.result.team_up_products;
            }
            if (response.data.result.you_may_also_like) {
              this.you_may_also_like = response.data.result.you_may_also_like;
            }
            if (response.data.result.similar_products) {
              this.similar_products = response.data.result.similar_products;
            }
            if (response.data.result.top_sellers) {
              this.top_sellers = response.data.result.top_sellers;
            }
            // this.$gtm.trackEvent({
            //   event: "ProductDetail",
            //   category: "Ecommerce",
            //   action: "Product Detail",
            //   label: this.name,
            //   ecommerce: {
            //     detail: {
            //       product: [
            //         {
            //           image: this.placeholder_image,
            //           name: this.name,
            //           id: this.master_sku,
            //           price: this.selling_price,
            //           category: this.product_cat,
            //         },
            //       ],
            //     },
            //   },
            // });
             this.get_review();
          } else {
            if (response.data.response.error_message === "no result") {
              return this.$router.push("/404");
            } else {
              this.$root.error_message = response.data.response.error_message;
            }
          }
          this.ProductDetailLoader = false;
        })
        .catch((error) => {
          console.log('error', error)
          
          // this.$root.page_l;
          // setTimeout(()=>{
          // this.$root.page_loader = false;

          // },1000)
          //this.$root.error_message = error.message;
        });
    },
    getRecent() {
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "recent_views",
            store: this.$route.query.store,
            recent_views_products: this.recent,
          },
        })
        .then((response) => {
          if(response.data.response.success == 1) {
            this.$root.error_message = ''
            this.recent_products = response.data.result;

          } else {
            this.$root.error_message = response.data.response.message
            this.recent_products = []

          }
          
        });
    },
    gift_add_to_cart: function (event) {
      this.$root.pcart = $cookies.get(
        window.location.hostname.substring(10, 4) + "_cart"
      );
      if (this.size.select_size != "") {
        if (
          this.gift_email != "" &&
          this.gift_phone != "" &&
          this.email_error == "" &&
          this.phone_error == ""
        ) {
          this.$root.page_loader = true;
          var form = new FormData();
          form.append("email", this.gift_email);
          form.append("phone", this.gift_phone);
          form.append("message", this.gift_message);
          form.append("product_id", this.size.variant_id);
          form.append("product_parent_id", this.pro_id);
          form.append("product_options", this.size.select_size);
          form.append("name", this.name);
          form.append("sku", this.size.sku);
          form.append("master_sku", this.master_sku);
          form.append("price", this.price);
          form.append("product_type", "gift");
          form.append("qty_ordered", this.qty);
          form.append("final_price", this.selling_price);
          form.append("store", this.$root.store);
          if (this.$root.pcart != null && this.$root.pcart != "") {
            form.append("pcart", this.$root.pcart);
            form.append("cart_session", this.$root.cart_session);
          }
          if (this.$root.customer_id != null && this.$root.customer_id != "") {
            form.append("customer_id", this.$root.customer_id);
            form.append("customer_session", this.$root.customer_session);
          }
          let config = { headers: { "Content-Type": "multipart/form-data" } };
          axios.post(this.$root.cart_api + "/product/add-product", form, config).then((response) => {
              if (response.data.success === true) {
                this.$toast.success("Product added to cart", {
                  position: "top",
                  duration: 4000,
                });
                this.$root.success_message = response.data.message;
                this.$root.error_message = "";
                this.$root.page_loader = false;
                this.$root.cart_product = response.data.data.products;
                this.$root.cart_total = response.data.data.grand_total;
                this.$root.cart_subtotal = response.data.data.order_subtotal;
                this.$root.discount_code = response.data.data.discount_code;
                this.$root.discount_amount = response.data.data.discount_amount;
                this.$root.address = response.data.data.address;
                if (this.$root.address.length != 0) {
                  for (let i = 0; i < this.$root.address.length; i++) {
                    if (i == 0) {
                      this.$root.address_id = this.$root.address[i].id * 1;
                      this.$root.select_address_no = i;
                    }
                  }
                }
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart,
                  "1y"
                );
                this.$root.pcart = response.data.data.pcart;
                if (response.data.data.cart_session) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    response.data.data.cart_session,
                    "1y"
                  );
                  this.$root.cart_session = response.data.data.cart_session;
                }
                this.$root.thankyou_cart = response.data.data.pcart;
                this.$gtm.trackEvent({
                  event: "addToCart",
                  category: "Ecommerce",
                  action: "Buy_now",
                  label: this.name,
                  ecommerce: {
                    currencyCode: "INR",
                    add: {
                      product: [
                        {
                          name: this.name,
                          id: this.master_sku,
                          price: this.selling_price,
                          variant: this.size.select_size,
                          quantity: this.qty,
                          category: this.product_cat,
                        },
                      ],
                    },
                  },
                });
                setTimeout(
                  () =>
                    this.$gtm.trackEvent({
                      event: "checkout",
                      category: "Ecommerce",
                      action: "Buy_now",
                      label: "1",
                      ecommerce: {
                        checkout: {
                          actionField: {
                            step: 1,
                            option: this.$root.login_status,
                          },
                          product: this.$root.gtm_product,
                        },
                      },
                    }),
                  100
                );

                this.$router.push("checkout.html");

                this.size.select_size = "";
              } else {
                this.$root.success_message = "";
                this.$root.error_message = response.data.message;
                this.$root.page_loader = false;
                if (response.data.cart_session_status == false) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    "",
                    "1y"
                  );
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    "",
                    "1y"
                  );
                  if(response.data.message != this.$root.keepCartMessage) {
                    this.$root.pcart = "";
                    this.$root.cart_session = "";
                    this.$root.cart_product = [];

                  }
                  
                }
                if (response.data.customer_session_status == false) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_customer",
                    "",
                    "1y"
                  );
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cs",
                    "",
                    "1y"
                  );
                  this.$root.customer_id = "";
                  this.$root.customer_session = "";
                }
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              this.$root.error_message = error.message;
              window.scrollTo(0, 0);
            });
        } else {
          this.size_active = false;
          this.gift_message_f();
          this.gift_email_f();
          this.gift_phone_f();
        }
      } else {
        this.size_active = false;
        this.size_error = "Please select a gift value first";
      }
    },
    // toastMessageFunction()
    // {
    //   this.toastMessage = false;
      
    // },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    buyNow() {
      this.isBuyNow = true;
      this.add_to_cart();
    },
    formatPrice(value, precision = false) {
      let val;

      if (precision) val = (value / 1).toFixed(2).replace(",", ",");
      else val = (value / 1).toFixed(0).replace(",", ",");

      return `<span>&#8377;</span> ${val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        .replace(".00", "<small>.00</small>")} `;
    },
    formatDiscountPrice(value) {
      let val;
      return (val = (value / 1).toFixed(0).replace(",", ","));
    },
    add_to_cart: function (event, store) {
      this.$root.pcart = $cookies.get(
        window.location.hostname.substring(10, 4) + "_cart"
      );
      if (this.size.select_size != "" || this.isSelectableWithoutSize || this.isSelectSizeFromChart == false) {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("product_id", this.size.variant_id || this.product_id);
        form.append("product_parent_id", this.pro_id);
        form.append("product_options", this.size.select_size);
        form.append("name", this.name);
        form.append("sku", this.size.sku || this.sku);
        form.append("master_sku", this.master_sku);
        form.append("price", this.price);
        form.append("qty_ordered", this.qty);
        form.append("personalization_message",this.personilizationMessage)
        form.append("final_price", this.selling_price);
        form.append("s", [this.stores]);
        form.append("gi", this.goupId);
        form.append("ig", this.isGrocery);
        if (store) {
          form.append("store", parseInt(store));
        } else {
          form.append("store", this.$route.query.store);
        }
        // form.append("store", this.$route.query.store);
        form.append("latitude", this.$root.location.lat);
        form.append("longitude", this.$root.location.long);
        // form.append('pcart',0)

        if(this.$root.customer_id){
          form.append("customer_id", this.$root.customer_id);
        }
        if(this.$root.customer_session){
          form.append("customer_session", this.$root.customer_session);
        }
        if (this.$root.cart_product.length == 0 && !this.$root.pcart) {
          form.append("pcart", 0);
        } else {
          form.append("pcart", this.$root.pcart);
        }

        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios.post(this.$root.cart_api + "/product/add-product", form, config).then((response) => {
            if (response.data.success === true) {
            
              if (this.$root.numberOfStores < response.data.data.length) {
                this.diffStore=true;
                // this.$toast.success("You have added an item from a different store. Shipping charges may vary accordingly.", {
                //   position: "top",
                //   duration: 1000*300,
                // });
                // this.$toast.success("Product added to cart", {
                //   position: "top",
                //   duration: 4000,
                // });
                bus.$emit('buyingfromotherstores', 'You have added an item from a different store. Shipping charges may vary accordingly');
                // this.$toast.success("Product added to cart", {
                //   position: "top",
                //   duration: 4000,
                //   dismissable : false
                // });
                // this.toastMessage = true;
                
              } else {
                this.$toast.success("Product added to cart", {
                  position: "top",
                  duration: 4000,
                });
              }
              this.size = {
                select_size: "",
                max_qty: "1",
                variant_id: "",
                sku: "",
              };
              this.qty = 1;
              this.$root.error_message = "";
              this.personilizationMessage="";
              this.$root.page_loader = false;
              this.$root.cart_total = response.data.data.grand_total;
              this.$root.cart_subtotal = response.data.data.order_subtotal;
              this.$root.discount_code = response.data.data.discount_code;
              this.$root.discount_amount = response.data.data.discount_amount;
              this.$root.address = response.data.data.address;
              if (
                !this.$root.pcart &&
                this.$root.pcart != response.data.data.pcart
              ) {
                this.$root.pcart = response.data.data.pcart;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart,
                  "1y"
                );
              } else {
                this.$root.pcart = response.data.pcart;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.pcart,
                  "1y"
                );
              }

              if (response.data.data.length > 0) {
                this.$root.numberOfStores = response.data.data.length;

                //Products Array
                let ProductsArray = [];
                // Sorting Products array according to SKU
                this.$root.cart_total = 0;
                this.$root.cart_subtotal = 0;
                this.$root.cart_netAmount = 0;
                response.data.data.forEach((products) => {
                  this.$root.cart_total =
                    this.$root.cart_total + products.grand_total;
                  this.$root.cart_subtotal =
                    this.$root.cart_subtotal + products.order_subtotal;
                  this.$root.cart_netAmount =
                    this.$root.cart_netAmount + products.net_amount;

                  let sortedProducts = this.groupByKey(
                    products.products,
                    "sku"
                  );
                  //  console.log(sortedProducts);
                  // Creating Sorted Products Array
                  Object.keys(sortedProducts).map(function (key, index) {
                    ProductsArray.push(sortedProducts[key]);
                  });
                });

                // Modifying Price and Quantity accroding to SKU
                let data = [];
                let price = 0;
                ProductsArray.forEach((ele, index) => {
                  let qty = 0;
                  ele.forEach((product) => {
                    qty = qty + product.qty;
                    ele[0]["qty"] = qty;
                  });
                  data.push(ele[0]);
                });

                this.$root.cart_product = data;

                if (this.isBuyNow) {
                  this.$router.push("/checkout.html");
                }
              } else {
                // console.log("called else");
                this.$root.numberOfStores = response.data.data.length;
                this.$root.pcart = response.data.data.pcart;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart,
                  "1y"
                );

                (this.$root.cart_total = response.data.data.grand_total),
                  // net_amount:response.data.data.net_amount,
                  (this.$root.cart_subtotal =
                    response.data.data.order_subtotal);
                // products = response.data.data.products
                // this.$store.dispatch('getAmount', amount)

                this.$root.cart_product = response.data.data.products;
                if (this.isBuyNow) {
                  this.$router.push("/checkout.html");
                }
                //  this.$store.dispatch('getCart', response.data.data.products)
              }

              this.$root.minicart = false;

              // this.$root.pcart = response
              // if (this.$root.address.length != 0) {
              //     for (let i = 0; i < this.$root.address.length; i++) {
              //         if (i == 0) {
              //             this.$root.address_id = this.$root.address[i].id * 1;
              //             this.$root.select_address_no = i;
              //         }
              //     }
              // }

              // this.$root.pcart = response.data.data.pcart;
              this.$root.thankyou_cart = response.data.data.pcart;
              if (response.data.data.cart_session) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  response.data.data.cart_session,
                  "1y"
                );
                this.$root.cart_session = response.data.data.cart_session;
              }
              // if (event.target.title === "Buy now") {
              //     this.$gtm.trackEvent({
              //         event: 'addToCart',
              //         category: 'Ecommerce',
              //         action: 'Buy_now',
              //         label: this.name,
              //         ecommerce: {
              //             currencyCode: 'INR',
              //             add: {
              //                 product: [{
              //                     name: this.name,
              //                     id: this.master_sku,
              //                     price: this.selling_price,
              //                     variant: this.size.select_size,
              //                     quantity: this.qty,
              //                     category: this.product_cat,
              //                 }
              //                 ]
              //             }
              //         }
              //     });
              //     setTimeout(() => this.$gtm.trackEvent({

              //         event: 'checkout',
              //         category: 'Ecommerce',
              //         action: 'Buy_now',
              //         label: '1',
              //         ecommerce: {
              //             checkout: {
              //                 'actionField': { 'step': 1, 'option': this.$root.login_status },
              //                 product: this.$root.gtm_product,
              //             }
              //         }
              //     }), 100);
              //     this.$router.push('checkout.html');
              // }
              // else {
              //     this.$root.minicart = false;
              //     this.size_active = true;
              //     this.$gtm.trackEvent({
              //         event: 'addToCart',
              //         category: 'Ecommerce',
              //         action: 'Add_to_cart',
              //         label: this.name,
              //         ecommerce: {
              //             currencyCode: 'INR',
              //             add: {
              //                 product: [{
              //                     name: this.name,
              //                     id: this.master_sku,
              //                     price: this.selling_price,
              //                     variant: this.size.select_size,
              //                     quantity: this.qty,
              //                     category: this.product_cat,
              //                 }
              //                 ]
              //             }
              //         }
              //     });
              // }

              this.size.select_size = "";
            } else {
              this.$root.success_message = "";
              this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              // this.$root.error_message = response.data.message;
              this.$root.page_loader = false;
              
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = "";
                // this.$root.cart_session = "";
                // this.$root.cart_product = [];
             
            }
          })
          .catch((error) => {
            console.log('error response', error.response)
              // this.$root.pcart = "";
              // this.$root.cart_session = "";
              // this.$root.cart_product = [];
            console.log(error);
            this.$root.page_loader = false;
            // this.$root.error_message = error.message;
            window.scrollTo(0, 0);
          });
      } else {
        this.size_active = false;
        this.size_error = "Please select a size first";
      }
    },
    select_size: function (item) {
      if(item.stock_status == 'out-of-stock'){
        this.isSelectSizeFromChart = true;
      }
      this.stock_status = item.stock_status;
      console.log("In Select Size Function", item);
      this.size_error = "";
      this.qty = "1";
      this.selectProduct(item)
    },
    selectProduct(article) {
      this.pro_id = article.id_product
      this.master_sku = article.sku
      this.price = article.price
      // this.qty = article.quantity
      this.selling_price = article.selling_price
      // console.log(article)

    },
    size_close: function () {
      this.size_active = true;
    },

    return_polices: function () {
      axios.get(this.$root.api_url +`/pim/pimresponse.php?service=return_policy&store=${this.$route.query.store}`).then((response) => {
         
          if (response.data.result.return_policy[0].url_key) {
            this.return_policyCMS = response.data.result.return_policy[0];
          }
        });
    },
    emi: function(){
      axios
          .get(this.$root.cart_api + "/emi/emi-options")
          .then((response) => {
            this.emiPlans = response.data.data.emi_plans;
             let counter=0;
                for (let key in this.emiPlans) {
              
                   if(this.emiPlans[key].plans[24]){
                      let interest = parseFloat(this.emiPlans[key].plans[24]) / 1200;
                      let term=24
                      let top = Math.pow(1 + interest, term);
                      let bottom = top - 1;
                      let ratio = top / bottom;
                      let emi = parseInt(this.selling_price) * interest * ratio;
                         if(counter==0){
                           this.minEmiprice=emi
                           counter++;
                         }
                         else{
                           if(this.minEmiprice>emi){
                             this.minEmiprice=emi
                           }
                         }
                    }
                }
                
            this.getEmiPlansTableData(Object.keys(this.emiPlans)[0]);
          })
          .catch((err) => {
            console.log(err);
          });
    }
  },
  created() {
    let bodyTag = document.getElementsByTagName("body");
    bodyTag[0].classList.add("m_bottom");
    window.scrollTo(0, 0);
    this.return_polices();
    this.getCouponList();
    this.emi();
           
  },
  beforeMount() { 
			document.addEventListener("keyup", evt => {
				if (evt.keyCode == 27) {
					this.returnP_model = false;
          this.other_seller_popup = false;
				}
			});
      
		},
  mounted() {
    this.getSizeChart()
    // if(this.gallery.length > 0)
    // {
    // 	this.imageZoom();
    // }
    //this.imageZoom()
    $(".filterClose").click(function () {
      // alert('asdjldsjkoasdd');
      $(".rightFilterWrap").removeClass("showFilter");
    });
    let recaptchaScript = document.createElement("script");
    this.recent = $cookies.get(
      window.location.hostname.substring(10, 4) + "_recent"
    );
    recaptchaScript.setAttribute(
      "src",
      "https://embed.videodelivery.net/embed/r4xu.fla9.latest.js"
    );
    document.head.appendChild(recaptchaScript);
    (this.$root.error_message = ""),
      (this.$root.success_message = ""),
      this.getprodetail();
    if (this.recent != null) {
      this.getRecent();
    }
    this.pincode = $cookies.get(
      window.location.hostname.substring(10, 4) + "_pin"
    );
    if (this.pincode != "" && this.pincode != null) {
      this.pin_code();
    }
 
  },
};
</script>

<style scoped>
.personilization-msg-input{
  width: 85%;
  padding: 5px;
}
.minicart-toast {
  right: 40%;
  top: 100px;
  padding: 6px 6px;
  background: green;
  border-radius: 4px;
  margin-top: 0;
  position: fixed;
  -webkit-box-shadow: 0 1px 10px rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.08);
  -webkit-animation-duration: 0.7s;
  animation-duration: 0.7s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: notify-bounce-in-down-desktop;
  animation-name: notify-bounce-in-down-desktop;
}
.minicart-toast p {
  margin: 0;
  padding: 0;
  line-height: 40px;
  color: #fff;
  font-family: "Jost-medium";
  font-size: 15px;
}
.minicart-toast{ z-index: 2;}
.applyCouponloader {
  position: relative;
  top: 50%;
  left: 50%;
}
</style>